import { applicationResource, ApplicationResource } from '@witkac/kartamiejska-resources';
import { Application } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

export class ApplicationModule extends EntityModule<Application, ApplicationResource> {
  constructor() {
    super(applicationResource);

    this.actions = {
      ...this.actions,
      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: any): Promise<void> => {
        await this.resource.update(data.id as number, data);
      },

      /**
       * Usuwa pliki
       *
       * @param {*} context
       * @param {{id: number, mediaId: number}} data
       * @returns {Promise<Application>}
       */
      removeMedia: (context: any, data: { id: number; mediaId: number }): Promise<Application> =>
        this.resource.removeMedia(data).then(() => context.dispatch('get', data.id))
    };
  }
}

export default new ApplicationModule();
